<div *ngIf="showCard" class="container-list-order">

  <div class="columns center">

    <div class="column is-4-desktop is-6-tablet">

      <!-- LISTADO DE DIRECCIONES -->
      <div class="card-login flex-start">
        <img (click)="closeCard()" src="/assets/icons/close.svg" alt="" class="icon-close">
        <div class="container-wellcome">
          <span class="title text-center">Pedidos en curso</span>
          <span class="subtitle margin-top-05 text-center">Selecciona uno de tus pedidos <br> en curso para ver su estado</span>
        </div>
        <div *ngIf="gettingListOrders" class="column is-8 is-offset-2 center">
          <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
        <div *ngIf="listOrders.length == 0 && !gettingListOrders" class="container-list-address center">
          <span class="title">No tienes pedidos</span>
        </div>
        <div *ngIf="listOrders.length != 0 && !gettingListOrders" class="container-list-address">
          <div
            *ngFor="let order of listOrders; let i = index"
            class="item-address" (click)="openTrackingOrder(order)"  >
            <div class="info-address"  >
              <span class="name-address"> Pedido No. {{ i + 1 }} - {{ order.clientName }}</span>
              <span class="address"> {{ order.dateFormated }} </span>
            </div>
            <!-- <div class="container-icon-delete center">
              <span *ngIf="loading" >...</span>
              <img (click)="deleteAddress(address.id)" *ngIf="!loading" src="/assets/icons/delete-fill.svg" alt="" class="icon-delete">
            </div> -->
          </div>
        </div>
      </div>

    </div>

  </div>

</div>